export const BASE_URL = 'https://autism-api.darkube.app'
export const STALETIME = 1000 * 60 * 60 * 1